import React, {useState} from 'react';
import {MdNavigateNext,MdNavigateBefore} from "react-icons/md"

const Pagination = (props) => {
    const [current,setPage] = useState(props.page);

    const previosPages = (page) => {
        let list = [];
        for (var i = page - 3; i < page; i++) {
            const iPage = i;
            if (i >= 0) {
                list.push(
                    <span
                        key={i}
                        className="table-paginate-page"
                        onClick={() => changePage(iPage)}
                    >
                    {i + 1}
                    </span>
                );
            }
        }
        return list;
    }
    const nextPages = (page, pages) => {
        let list = [];
        for (var i = page + 1; i <= page + 3; i++) {
            const iPage = i;
            if (i < pages) {
                list.push(
                    <span
                        key={i}
                        className="table-paginate-page"
                        onClick={() => changePage(iPage)}
                    >
                        {i + 1}
                    </span>
                );
            }
        }
        return list;
    }
    const getSafePage = (page) => {
        if (Number.isNaN(page)) {
            page = props.page;
        }
        return Math.min(Math.max(page, 0), props.pages - 1);
    }

    const changePage = (page) => {
        page = getSafePage(page);
        setPage(page);
        if (props.page !== page) {
            props.onPageChange(page);
        }
    }

    const {page, pages, canPrevious, canNext} = props;
    return (
        <div className={'pagination-bottom'}>
            <div className="table-paginate">
                    <span
                        className={`table-paginate-prev ${page === 0 ? 'disabled' : ''}`}
                        onClick={() => {
                            if (!canPrevious) return;
                            changePage(page - 1);
                        }}
                        disabled={!canPrevious}
                    ><MdNavigateBefore/></span>
                {previosPages(current)}
                    <span className="table-paginate-current-page">{page + 1}</span>
                {nextPages(current, pages)}
                <span
                    className={`table-paginate-next ${page + 1 === pages ? 'disabled' : ''}`}
                    onClick={() => {
                        if (!canNext) return;
                        changePage(page + 1);
                    }}
                    disabled={!canNext}
                ><MdNavigateNext/></span>
            </div>
        </div>
    );
};

export default Pagination;